// 24시간 기준 쿠키 설정하기
// expiredays 후의 클릭한 시간까지 쿠키 설정
//expriedDay
export default function setCookie( name, value, expires ) {

   let expiredDay = new Date();

   if(expires instanceof Date){
      expiredDay = expires
   } else {
      expiredDay.setDate( expiredDay.getDate() + expires );
   }

   document.cookie = name + "=" + escape( value ) + "; path=/; expires=" + expiredDay.toGMTString() + ";"
}
